<!--  -->
<template>
  <div :class="['training', 'training-blockly-content', { mark: beMark }]">
    <ai-t-python-editor-head
      :project-id="projectId"
      :editor-id="editorId"
      :Project.sync="Project"
      :codeText="codeText"
      @getCodeByLocal="getCodeByLocal"
      @saveFile="saveFile"
      @onExecution="onExecution"
    ></ai-t-python-editor-head>
    <div class="training-area">
      <Toolbox
        :projectId="projectId"
        :Media="Media"
        @getMedia="getMedia"
        @getDocument="getDocument"
        @showHandler="showHandler"
      ></Toolbox>
      <python-editor v-model="pythonEditorCode"  :class="['python-editor-content', { 'python-editor-content-open': !sidebarSwitch }]"></python-editor>
      <Markdown-Doc
        :document="markdownDoc"
        :show="documentShow"
        @showHandler="showHandler"
      />
      <Code-run
        :codeText="codeText"
        :mode="mode"
        @runHandle="runHandle"
        @sidebarSwitchHandle="sidebarSwitchHandle"
        :Project.sync="Project"
        :project-id="projectId"
        :workspaceIsVisible="false"
        ref="codeRun"
        v-bind="$attrs"
        v-on="$listeners"
        v-show="!documentShow"
      >
      </Code-run>
      <guide-tool :path="hashId"></guide-tool>
    </div>

    <div class="popup-list popup-list3">
      <!-- 离开时保存提示弹框  -->
      <gat-popup
        :class="[
          'popup-leave-save',
          popupActive === 'leave-save' ? 'on' : 'off',
        ]"
        :title="'是否保存项目？'"
        :primary-button="'确定'"
        :cancel-button="'否'"
        @cancel="confirmLeaveSave"
        @confirm="confirmLeaveSave(true)"
      >
        <template v-slot:content>
          <span></span>
        </template>
      </gat-popup>

      <!-- 不创建项目提示：继续创建在本页面，取消则退回上一页-->
      <gat-popup
        :class="['popup-execution', popupActive === 'execution' ? 'on' : 'off']"
        :title="''"
        :primary-button="'确定'"
        @cancel="cancelPopup"
        @confirm="executionProject"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <span class="title">是否退出新建项目？</span>
            </div>

            <div class="content">确定退出将返回首页</div>
          </div>
        </template>
      </gat-popup>
    </div>

  </div>
</template>

<script>
import PythonEditor from '@/components/common/PythonEditor'
import Toolbox from '@/components/blocklyEditor/common/document/Toolbox.vue'
import MarkdownDoc from '@/components/blocklyEditor/common/document/MarkdownDoc.vue'
import AiTPythonEditorHead from '@/views/projects/AiTPythonEditor/components/AiTPythonEditorHead.vue'
import CodeRun from '@/components/blocklyEditor/common/codeRun.vue'
import PERSONAL from '@/axios/personalSpace/personalSpace.js'
import GatPopup from '@/components/common/GatPopup'
import GuideTool from '@/components/guide/GuideTool.vue'
import bus from '@/utils/bus'
import { debounce } from 'lodash'
import AI_EDITOR from '@/axios/personalSpace/AiEditor/blocks.js'
export default {
  name: 'AiTpythonEditorHome',
  components: {
    PythonEditor,
    AiTPythonEditorHead,
    CodeRun,
    GatPopup,
    Toolbox,
    MarkdownDoc,
    GuideTool,
  },
  data() {
    return {
      pythonEditorCode: '',
      projectId: '',
      editorId: '',
      mode: '',
      hashId: 'ai-t-python-editor',
      workspaceIsVisible: true,
      homeWorkStatus: false,
      beMark: false, //遮罩层
      popupActive: '',
      sidebarSwitch: true,
      markdownDoc: '', //markdown文档内容
      documentShow: true,
      Media: [],
      Project: {
        //项目信息存储
        projectId: '00000000-0000-0000-0000-000000000000',
        projectName: '',
        blocksFileUrl: '',
      },
      Icons: {
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
        },
      },
    }
  },
  computed: {
    codeText: {
      set(val) {},
      get() {
        return this.pythonEditorCode
      },
    },
  },
  watch: {
    pythonEditorCode(val) {},
  },
  created() {
    let self = this
    let query = this.$route.query
    if (query) {
      //全局变量，判断是否为老师角色从评分进来
      this.projectId = query.projectId
      this.editorId = query.editorId
      this.mode = query.mode
      this.$store.state.blocklyHome.createBy = query.createBy
    }
    //离开前监听
    bus.$on('beforeLeave', async (type) => {
      self.leaveType = type
      self.beforeLeave()
    })

    window.addEventListener('beforeunload', (e) => {
      console.log('e', e)
    })
  },
  mounted() {
    this.getProjectByProjectId()
    this.getMedia()
  },
  methods: {
    runHandle() {
      this.$store.state.blocklyHome.codeText = this.pythonEditorCode + '\n'
    },
    showHandler(val) {
      this.documentShow = val
    },

    //获取markdown文档
    getDocument(text) {
      this.markdownDoc = text

      this.$store.commit('setMarkdownDoc', text)
    },
    /**
    获取个人空间项目详情数据 @data projectId
  */
    async getProjectByProjectId() {
      let res,
        data = {
          projectId: this.projectId,
        }

      res = await PERSONAL.getProjectByProjectId(data)
      if (res.isSuccess && res.data) {
        this.Project = res.data
        if (res.data.pythonCode) {
          this.pythonEditorCode = res.data.pythonCode
        }
      }
      return res
    },
    //保存项目文件功能 runType 保存或者是另存为，显示提示不一样
    async saveFile(id) {
      if (!this.projectId) return
      var projectId = id || this.projectId,
        data = {},
        result,
        msg = id ? '保存成功' : '保存成功',
        pythonCodeText = this.codeText

      data = {
        pythonCode: pythonCodeText,
        projectId,
      }
      result = await PERSONAL.savePythonProjectCode(data)
      if (result && result.isSuccess) {
        this.$message.success(result.returnMsg)
      } else if (result) {
        this.$message.error(result.returnMsg)
      }
      return result
    },
    getMedia() {
      let { projectId } = this,
        data = {}
      if (projectId) {
        //ai-T编辑器里根据trainingId获取媒体积木
        data = {
          projectId,
        }
        return AI_EDITOR.getMediaByTrainingId(data).then((result) => {
          if (result.isSuccess) {
            this.Media = result.data
          }
        })
      }
    },
    getCodeByLocal(val) {
      this.pythonEditorCode = val
    },
    beforeLeave() {
      this.popupActive = 'leave-save'
    },
    async confirmLeaveSave(val) {
      let leaveType = this.leaveType
      // console.log('leaveType',leaveType)

      let editorId = this.editorId
      // 点击删除按钮时，不退出页面，弹框消失；
      if (!val || val === 'firstOff') {
        return (this.popupActive = '')
      }
      if (val === true) {
        await this.saveFile() //保存项目
      }
      //退出操作
      switch (leaveType) {
        case 'back': {
          this.$router.push({
            name: 'projects-list',
            query: { editorId },
          })
          break
        }
        default: {
          this.$router.push('/')
          break
        }
      }

      this.leaveType = ''
      this.popupActive = ''
    },
    // 重绘工作区大小
    sidebarSwitchHandle(switchObj) {
      this.sidebarSwitch = switchObj.sidebarSwitch
      // bus.$emit('onSidebarSwitch')
    },
    // 退出提示弹窗
    onExecution() {
      this.popupActive = 'execution'
    },
    // 退出提示确认
    //防抖函数
    executionProject: debounce(function(type) {
      // this.$router.go(-1)
      this.$router.push({name: 'home'});
    }, 300),
    // 取消弹窗
    cancelPopup(val) {
      this.popupActive = ''
      this.scoreForm = ''
    },
  },
  beforeMount() {},
  // beforeRouteLeave(to, from, next) {
  // },
  destroyed() {},
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
@import './AiTPythonBlockEditorHome.scss';
.guide-tool-btn {
  position: absolute;
  z-index: 100;
}
</style>
